var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 46C10.3212 46 0 35.6811 0 23.0051C0 10.329 10.3212 0 23 0C35.6788 0 46 10.3189 46 22.9949C46 35.671 35.689 46 23 46ZM23 1.50737C11.1509 1.50737 1.5077 11.1484 1.5077 22.9949C1.5077 34.8414 11.1509 44.4825 23 44.4825C34.8491 44.4825 44.4923 34.8414 44.4923 22.9949C44.4923 11.1484 34.8592 1.50737 23 1.50737Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9073 33.9208L21.7753 25.8983L14.7529 33.9208H11.7476L20.3688 24.0672L11.2012 12.0791H18.2944L23.8497 19.4237L30.2751 12.0791H33.2804L25.2359 21.2649L34.8083 33.9106H27.9073V33.9208ZM28.6561 32.2414H31.5298L17.4445 13.6269H14.4189L28.6561 32.2414Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.7a0a1309e4f9e1aa67aa9182d1180d76.svg";
export { ForwardRef as ReactComponent };